import { useHeader } from 'utils/use-header'

import BreadCrumbs from 'components/ui/bread-crumbs'

import { useTranslation } from 'utils/use-translation'

import MainBlock from './components/main-block'
import { OurPartners } from './components/our-partners'
import PressAboutUs from './components/press-about-us'
import Collaborate from './components/collaborate'
import Badges from './components/badges'

export default function AboutUs() {
  const { t } = useTranslation()

  const head = useHeader(
    t('about_crypto_lending_platform'),
    t('coinrabbit_definition') + t('check_out'),
    null,
    4,
    t('about'),
  )

  return (
    <>
      {head}
      <MainBlock />
      <OurPartners />
      <PressAboutUs />
      <Badges />
      <Collaborate />
      <BreadCrumbs pages={[{ name: t('about_us_capital'), url: '' }]} />
    </>
  )
}
